import { useState } from 'react'

import { AttentionBox } from '@cais-group/equity/molecules/attention-box'

/**
 * Uses intrinsic sizing to animate height auto
 * https://developer.chrome.com/docs/css-ui/animate-to-height-auto
 *
 */
export function CustomFirmDisclosure(props: { text: string }) {
  const [isVisible, setIsVisible] = useState(true)

  return (
    <div
      aria-label="Custom firm disclosure"
      role="region"
      className={`bg-neutral-0 tr-decelerate-short-2-all overflow-clip ${
        isVisible ? 'opacity-1 h-auto' : 'h-0 opacity-0'
      }`}
    >
      <div className="p-32">
        <AttentionBox onDismiss={() => setIsVisible(false)}>
          <p className="small text-neutral-600">{props.text}</p>
        </AttentionBox>
      </div>
    </div>
  )
}
